import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type TitleOfferFragment = {
	__typename?: 'Offer';
	id: string;
	presentationType: Types.PresentationType;
	monetizationType: Types.MonetizationType;
	retailPrice?: string | null;
	retailPriceValue?: number | null;
	currency?: string | null;
	lastChangeRetailPriceValue?: number | null;
	type: Types.OfferType;
	standardWebURL?: string | null;
	elementCount?: number | null;
	availableTo?: any | null;
	subtitleLanguages: Array<any>;
	videoTechnology: Array<Types.VideoTechnology>;
	audioTechnology: Array<Types.AudioTechnology>;
	audioLanguages: Array<any>;
	deeplinkRoku?: string | null;
	package: {
		__typename?: 'Package';
		id: string;
		packageId: number;
		clearName: string;
		technicalName: string;
		icon: string;
	};
};

export type FastOfferFragment = {
	__typename?: 'Offer';
	availableTo?: any | null;
	availableFromTime?: any | null;
	availableToTime?: any | null;
	id: string;
	presentationType: Types.PresentationType;
	monetizationType: Types.MonetizationType;
	retailPrice?: string | null;
	retailPriceValue?: number | null;
	currency?: string | null;
	lastChangeRetailPriceValue?: number | null;
	type: Types.OfferType;
	standardWebURL?: string | null;
	elementCount?: number | null;
	subtitleLanguages: Array<any>;
	videoTechnology: Array<Types.VideoTechnology>;
	audioTechnology: Array<Types.AudioTechnology>;
	audioLanguages: Array<any>;
	deeplinkRoku?: string | null;
	package: {
		__typename?: 'Package';
		id: string;
		packageId: number;
		clearName: string;
		technicalName: string;
		icon: string;
	};
};

export const TitleOfferFragmentDoc = gql`
	fragment TitleOffer on Offer {
		id
		presentationType
		monetizationType
		retailPrice(language: $language)
		retailPriceValue
		currency
		lastChangeRetailPriceValue
		type
		package {
			id
			packageId
			clearName
			technicalName
			icon(profile: S100)
		}
		standardWebURL
		elementCount
		availableTo
		deeplinkRoku: deeplinkURL(platform: ROKU_OS)
		subtitleLanguages
		videoTechnology
		audioTechnology
		audioLanguages
	}
`;
export const FastOfferFragmentDoc = gql`
	fragment FastOffer on Offer {
		...TitleOffer
		availableTo
		availableFromTime
		availableToTime
	}
	${TitleOfferFragmentDoc}
`;
